import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import { getMonitorDistributions } from "store/monitor-distributions/monitor-distribution-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
  getMonitorProvinces,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorDistributionComponents from "components/MonitorDistributions/list"
import ProviderOutDetailModal from "components/ProviderOut/details"
import { exportMonitorDistributionReport } from "store/monitor-reports/monitor-report-action"

const MonitorDistributions = () => {
  // Meta Title
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(
    state => state.monitorDistributions
  )

  // Current status of the export process for the consumption report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.monitorReports.monitorExportDistributionReport
  )
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorDistributions(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getMonitorDistributions(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorDistributions(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch distribution and other data need for filter
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorProvinces())
    dispatch(getMonitorIps())
    dispatch(getMonitorProjects())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorDistributions(undefined, undefined, undefined, search, data)
    )
  }

  // Show distribution details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportMonitorDistributionReport(
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  return (
    <React.Fragment>
      {/* Monitor Tiles */}
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Distributions"} />
      {/* Distribution Detail Modal  */}
      <ProviderOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />
      {/* Monitor Distribution List Component  */}
      <MonitorDistributionComponents
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default MonitorDistributions
